import React from 'react';
import {
	GetMemberProgramQuery,
	ProgramContentItemCategory,
} from 'src/graphqlTypes/catalogServiceTypes';
import { ProgramContentItems } from 'src/components/ProgramDetails/ProgramContentItems';
import { useSearchContext } from '@src/components/Providers/SearchProvider';
import { employerIds } from '@src/constants/employerResources';

interface Props {
	programContentItems: GetMemberProgramQuery['memberProgram']['contentItems'];
	programId: string;
}

export const OtherRequirements: React.FC<Props> = ({ programContentItems, programId }) => {
	const { employerUuid } = useSearchContext();
	const isWalmart = employerUuid === employerIds.walmart;

	const otherRequirements = programContentItems.filter(
		item => item.category === ProgramContentItemCategory.REQUIREMENTS_OTHER
	);

	if (otherRequirements.length === 0) {
		return null;
	}

	return (
		<ProgramContentItems
			ariaLabel='other requirements'
			contentItems={otherRequirements}
			sectionTitle='Other'
		/>
	);
};
